import { useEffect, useState } from 'react';
import DOMPurify from 'dompurify';
import CircleStyleTextBox from '../circleStyleTextBox/circleStyleTextBox';
import styles from './header.module.css';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import VideoAlert from '../../video-alert';
gsap.registerPlugin(ScrollTrigger);

const Header = ({ m2sText, language = 'cn', productId }) => {
  const [productLoading, setproductLoadingLoading] = useState(true);
  const [productReflectionLoading, setProductReflectionLoading] =
    useState(true);
  const [animate, setAnimated] = useState(false);

  useEffect(() => {
    headerAnimation();
  });

  useEffect(() => {
    new VideoAlert({
      havePathElement: '.tvc-button',
      alertStyle: {
        'max-wixth': 1200,
        width: 'calc(100vw - 32px)',
      },
    });
  });

  const headerAnimation = () => {
    // hero animation
    {
      //   const currentFrame = (index) =>
      //     `https://bucket.zhiyun-tech.com/detail/m3-hero/m3-${(index + 1)
      //       .toString()
      //       .padStart(5, '0')}.jpg`;

      // const currentFrame = (index) =>
      //   `./imgs/m2s-${(index + 1).toString().padStart(5, '0')}.jpg`;

      const currentFrame = (index) =>
        `https://bucket.zhiyun-tech.com/detail/m2s/m2s-animation/m2s-${(
          index + 1
        )
          .toString()
          .padStart(5, '0')}.jpg`;

      const canvas = document.querySelector(`.${styles.headerAnimation}`);
      const context = canvas.getContext('2d');
      canvas.width = 640;
      canvas.height = 720;
      const frameCount = 49;
      const images = [];
      const craneM3 = {
        frame: 0,
      };

      for (let i = 0; i < frameCount; i++) {
        const img = new Image();
        img.src = currentFrame(i);
        images.push(img);
      }

      images[craneM3.frame].onload = render;

      function render() {
        context.clearRect(0, 0, canvas.width, canvas.height);
        context.drawImage(images[craneM3.frame], 0, 0);
        console.log(images[craneM3.frame]);
      }

      let tl = gsap.timeline({
        scrollTrigger: {
          trigger: '.animationCtn',
          pin: true,
          scrub: 1.4,
          end: '360%',
        },
      });

      tl.to('.header-img-box', {
        y: 0,
        duration: 24,
      });

      tl.to(
        `.${styles.ctn}`,
        {
          '--m2s-header-background-mask-opacity': 1,
          duration: 6,
        },
        1,
      );
      tl.to(
        document.querySelector('.header-img-box > img'),
        {
          opacity: 0,
          duration: 6,
        },
        7,
      );

      tl.to(
        document.querySelector('canvas'),
        {
          opacity: 1,
          duration: 0.1,
        },
        7,
      );
      tl.fromTo(
        `.${styles.productShadow}`,
        {
          scale: 1,
          opacity: 0.6,
        },
        {
          scale: 1.4,
          opacity: 0,
          duration: 2,
        },
        0,
      );
      tl.fromTo(
        `.${styles.productReflection}`,
        {
          y: 0,
        },
        {
          y: 40,
          opacity: 0,
          duration: 2,
        },
        0,
      );
      tl.to(
        craneM3,
        {
          frame: 1,
          snap: 'frame',
          onUpdate: render,
          duration: 2,
        },
        0,
      );

      tl.fromTo(
        '.headerH3',
        {
          y: 0,
          opacity: 1,
        },
        {
          y: -60,
          opacity: 0,
          duration: 3,
        },
        0,
      );

      tl.fromTo(
        '.headerH1',
        {
          scale: 1,
          y: 0,
          opacity: 1,
        },
        { y: -60, opacity: 0, duration: 3 },
        0.4,
      );

      tl.to(`.${styles.headerTextItem1}`, {
        visibility: 'hidden',
      });

      tl.fromTo(
        `.${styles.tvcPlayButton}`,
        {
          y: 0,
          opacity: 1,
        },
        { y: -60, opacity: 0, duration: 3 },
        0.4,
      );

      tl.to(
        `.${styles.headerTextItem2}`,
        {
          opacity: 1,
          y: 0,
          duration: 6,
        },
        3,
      );

      tl.to(
        `.${styles.headerTextItem2}`,
        {
          opacity: 0,
          y: -80,
          duration: 6,
        },
        11,
      );
      tl.to(
        '.headerCarryH2',
        {
          opacity: 1,
          y: 0,
          duration: 6,
        },
        17,
      );
      tl.to(
        '.headerCarryH5',
        {
          opacity: 1,
          y: 0,
          duration: 6,
        },
        17.4,
      );
      tl.to(
        craneM3,
        {
          frame: 18,
          snap: 'frame',
          onUpdate: render,
          duration: 17,
        },
        20,
      );

      tl.to(
        '.headerCarryH2',
        {
          opacity: 0,
          y: -100,
          duration: 10,
        },
        34,
      );
      tl.to(
        '.headerCarryH5',
        {
          opacity: 0,
          y: -100,
          duration: 10,
        },
        34,
      );
      tl.to(
        craneM3,
        {
          frame: 48,
          snap: 'frame',
          onUpdate: render,
          duration: 10,
        },
        42,
      );
      tl.to(
        '.headerLightnessH2',
        {
          opacity: 1,
          y: 0,
          duration: 10,
        },
        42,
      );
      tl.to(
        '.headerLightnessH6',
        {
          opacity: 1,
          visibility: 'visible',
          y: 0,
          duration: 10,
        },
        52.4,
      );
      tl.to('.headerLightnessH2', {
        opacity: 1,
        y: 0,
        duration: 6,
      });
      // tl.to(
      //   craneM3,
      //   {
      //     frame: 40,
      //     snap: 'frame',
      //     onUpdate: render,
      //     duration: 10,
      //   },20
      // );
    }
  };

  return (
    <div className="animationCtn">
      <div className={`${styles.ctn} m2s-section fullscreen `}>
        <div className={styles.mediaBox}>
          <div className={`${styles.imgBox} header-img-box`}>
            <canvas className={`${styles.headerAnimation}`}></canvas>
            <img
              src="https://bucket.zhiyun-tech.com/detail/m2s/m2s-device-1.png"
              alt=""
              onLoad={() => {
                setproductLoadingLoading(false);
              }}
            />
          </div>

          <div className={styles.productEffects}>
            <div className={styles.productShadow}></div>
            <img
              className={styles.productReflection}
              src="https://bucket.zhiyun-tech.com/detail/m2s/m2s-device-reflection.png"
              alt=""
              onLoad={() => {
                setProductReflectionLoading(false);
              }}
            />
          </div>
        </div>

        <CircleStyleTextBox className={styles.headerTextBox}>
          <div className={styles.headerTextItem1}>
            <h3 className="headerH3">
              <div className="m2s-primary-text">CRANE-M2 S</div>
            </h3>
            <h1
              className="headerH1"
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(m2sText['text1']),
              }}
            ></h1>
            <div
              class={`${styles.tvcPlayButton} tvc-button m2s-desktop m2s-tvc-button-desktop`}
              data-video-src={`https://bucket.zhiyun-tech.com/detail/m2s/m2s-tvc-${language === 'cn' ? 'cn' : 'en'}.mp4`}
              style={{
                '--m2s-tvc-button-offset-x': language === 'cn' ? '36px' : 0,
              }}
            >
              {m2sText['text31']}
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M10 8L16 12L10 16V8Z"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
          </div>

          <div className={styles.headerTextItem2}>
            <h4
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(m2sText['text2']),
              }}
            ></h4>
          </div>

          <div className={styles.headerTextItem3}>
            <h2
              className="headerCarryH2"
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(m2sText['text3']),
              }}
            ></h2>

            <h5
              className="headerCarryH5"
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(m2sText['text4']),
              }}
            ></h5>
          </div>

          <div className={styles.headerTextItem4}>
            <h3
              className="headerLightnessH2"
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(m2sText['text5']),
              }}
            ></h3>

            <h6 className="headerLightnessH6">
              <a
                href={`https://www.zhiyun-tech.com/${language}/download/software/${productId}/1/show?type=website&page=second_nav&source=download`}
                className="m2s-link"
              >
                {m2sText['text6']}
              </a>
            </h6>
          </div>
        </CircleStyleTextBox>

        <div
          class={`${styles.tvcPlayButton} tvc-button m2s-mobile`}
          data-video-src={`https://bucket.zhiyun-tech.com/detail/m2s/m2s-tvc-${language}.mp4`}
          style={{
            '--m2s-tvc-button-offset-x': language === 'cn' ? '36px' : 0,
          }}
        >
          {m2sText['text31']}
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
              stroke="white"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M10 8L16 12L10 16V8Z"
              stroke="white"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
      </div>
    </div>
  );
};

export default Header;
